export const locale = {
    lang: 'es',
    data: {
        LIST_CLINIC_MESSAGE: {
            TITLE: 'Mensaje',
            RESOLVE: 'Resolver',
            REOPEN: 'Reabrir',
            EMPTY_MESSAGE: {
                TITLE: 'Ningún mensaje seleccionado',
                DESCRIPTION: 'Seleccione el pedido al lado',
            },
            EMPTY_ORDER_MESSAGE: 'Ningún pedido encontrado',
            EMPTY_ORDER_SEARCH_MESSAGE: 'Busque un pedido',
            REMAKE_TYPE: {
                REMAKE: 'Repetición',
                REMAKE_INITIAL: 'R',
                ADJUSTMENT: 'Ajuste',
                ADJUSTMENT_INITIAL: 'A',
            },
            EMPTY_PATIENT: 'Paciente no definido',
            DELETED_MESSAGE: 'Mensaje eliminado',
            COMPLETE_DATE_FORMAT: "dd 'de' MMMM 'de' yyyy",
            TAGS: {
                OPEN: 'Abierto',
                NOT_READ: 'No leídos',
                RESOLVED: 'Resueltos',
            },
            FORM: {
                FIELDS: {
                    MESSAGE: 'Escribe tu mensaje',
                    SEARCH_ORDER_MESSAGE: 'Buscar por número de pedido, cliente o paciente',
                },
            },
            MAT_MENU: {
                FILES: 'Archivos',
                PHOTOS_AND_VIDEOS: 'Fotos y videos',
            },
            TOASTR: {
                ERRORS: {
                    PHOTO_VIDEO: 'Solo se permiten imágenes o videos.',
                    FILE: 'Solo se permiten archivos que no sean imágenes o videos.',
                    MAX_FILE: 'Se permiten un máximo de 15 archivos.',
                    MAX_FILE_SIZE: 'No se permite la carga de archivos de más de 150 MB.',
                },
            },
            MODAL: {
                GENERAL: {
                    BUTTONS: {
                        CONFIRM: 'Enviar',
                        CANCEL: 'Cancelar',
                    },
                },
                PREVIEW: {
                    TITLE: 'Vista previa',
                },
                IMAGE: {
                    TITLE: 'Ver imagen',
                },
            },
            DIALOG: {
                GENERAL: {
                    BUTTONS: {
                        CANCEL: 'Cancelar',
                        REOPEN: 'Reabrir',
                    },
                },
                REOPEN: {
                    TITLE: 'Reabrir conversación',
                    DESCRIPTION: '¿Estás seguro de que deseas reabrir esta conversación?',
                },
            },
        },
    },
};
